import React from "react";

const MenuButton = ({ actions }) => {
  return (
    <button
      onClick={actions.handleGoToMenu}
      className="border border-customBlue hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
    >
      🏠 Go to Menu
    </button>
  );
};

export default MenuButton;
